import React from 'react';

const Header = ({ menuItems, activeTab, user }) => {
  return (
    <header className="bg-white/80 backdrop-blur-md shadow-sm border-b border-slate-200/60 relative">
      <div className="relative z-10 px-8 py-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-slate-800">
              {menuItems.find(item => item.id === activeTab)?.name || 'Dashboard'}
            </h2>
            <p className="text-slate-500 mt-1">
              {menuItems.find(item => item.id === activeTab)?.description || 'Painel principal'}
            </p>
          </div>
          <div className="flex items-center space-x-6">
            <div className="text-right">
              <p className="text-sm font-semibold text-slate-700">
                {new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })}
              </p>
              <p className="text-xs text-slate-400">
                {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
            <div className="w-10 h-10 bg-gradient-to-br from-blue-100 to-teal-100 rounded-full flex items-center justify-center">
              <span className="text-blue-600 font-semibold">{user?.name?.charAt(0)}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
